import { XStack, type XStackProps } from 'tamagui';

import { Text } from '@/components/text';
import { LogoMark } from '@/components/logo-mark';

// Matches the landing page's .wordmark exactly (landing/styles.css,
// index.html's header <a class="wordmark">) -- the logo mark plus a
// small Space Mono uppercase brand label, not a display heading. Every
// screen that names the app should use this, not ad hoc "Nearkin" text.
export function Wordmark(props: XStackProps) {
  return (
    <XStack alignItems="center" gap="$2" {...props}>
      <LogoMark size={24} />
      <Text
        fontFamily="$mono"
        fontWeight="$semibold"
        fontSize="$meta"
        lineHeight="$meta"
        letterSpacing={1}
        textTransform="uppercase"
        color="$color"
      >
        Nearkin
      </Text>
    </XStack>
  );
}
